import React from 'react';
import Checkbox from '../../../../common/Checkbox';

const columns = {
  name: {
    accessor: 'name',
    Header: 'Tax Name',
  },
  percentage: {
    accessor: 'percentage',
    Header: 'Percentage',
  },
  shops: {
    accessor: 'shops',
    Header: 'Shops',
  },
  addToPrice: {
    accessor: 'addToPrice',
    Header: 'Add to price',
    Cell: row => (<Checkbox checked={row.value} readOnly />),
  },
  externalOrdersOnly: {
    accessor: 'externalOrdersOnly',
    Header: 'External orders only',
    Cell: row => (<Checkbox checked={row.value} readOnly />),
  },
  enabled: {
    accessor: 'enabled',
    Header: 'Enabled',
    Cell: row => (<Checkbox checked={row.value} readOnly />),
  },
};

export default columns;
